import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, space, transition } from './neonUtil'
import { DOT_PREFIX } from './constant'

const focusGlow = `0 0 0 1px ${cyan[500]}20, 0 0 4px ${cyan[500]}10 !important`

export default genComponentStyleHook(['Input', 'cyberTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 2,
      background: `${space[800]} !important`,
      borderColor: `${cyan[500]}20 !important`,
      color: `${cyan[100]} !important`,
      caretColor: cyan[500],

      '&::placeholder': {
        color: `${cyan[800]} !important`,
      },

      '&:hover': {
        borderColor: `${cyan[500]}50 !important`,
      },

      '&:focus, &-focused': {
        borderColor: `${cyan[500]}80 !important`,
        boxShadow: focusGlow,
      },

      // 前缀/后缀图标
      [`${componentCls}-prefix, ${componentCls}-suffix`]: {
        color: `${cyan[600]} !important`,
      },
    },

    // Input 包裹器 (affix-wrapper)
    [`${componentCls}-affix-wrapper${DOT_PREFIX}`]: {
      transition,
      borderRadius: 2,
      background: `${space[800]} !important`,
      borderColor: `${cyan[500]}20 !important`,

      '&:hover': {
        borderColor: `${cyan[500]}50 !important`,
      },

      '&-focused': {
        borderColor: `${cyan[500]}80 !important`,
        boxShadow: focusGlow,
      },
    },
  }
})
